module.exports = __webpack_public_path__ + "static/media/317441HD_Orientation_CVOD.9d60aa42.mp4";